import { Component, OnInit, Input } from '@angular/core';
import { PaginationSortingService } from 'src/app/services/paginationsorting.service';

@Component({
  selector: 'app-paging',
  templateUrl: './paging.component.html',
  styleUrls: ['./paging.component.scss']
})
export class PagingComponent implements OnInit {

  @Input() pageNumber: number;

  constructor(
    private paginationSortingService: PaginationSortingService
  ) {
    paginationSortingService.reset();
  }

  ngOnInit(): void {
    let pageNoVal = '' + this.pageNumber;
    if (pageNoVal !== '0') {
      pageNoVal = +pageNoVal - 1 + '';
    }
  }

}
